'use client';
import * as TabsPrimitive from '@radix-ui/react-tabs';
import * as React from 'react';
import { c } from '../../../utils/tailwind-merge';
import { TabsListProps, TabsTriggerLinkProps } from './Tabs.types';

function TabsRoot({
  className = '',
  ...props
}: React.ComponentProps<typeof TabsPrimitive.Root>) {
  return (
    <TabsPrimitive.Root
      data-slot="tabs"
      className={c('block w-full min-w-0', className)}
      {...props}
    />
  );
}

function TabsList({ className = '', ariaLabel, ...props }: TabsListProps) {
  return (
    <TabsPrimitive.List
      data-slot="tabs-list"
      data-test="tabs-list"
      className={c(
        'flex w-full min-w-0 items-center gap-x-4 border-b border-line-medium px-0',
        className
      )}
      aria-label={ariaLabel}
      {...props}
    />
  );
}

function TabsTrigger({
  className = '',
  ...props
}: React.ComponentProps<typeof TabsPrimitive.Trigger>) {
  const tabTriggerBase =
    'relative inline-flex -mb-px px-2 py-3 text-[16px] font-normal leading-[24px] tracking-tighter';
  const tabTriggerColors =
    'text-content-muted dark:data-[state=active]:text-content';
  const tabTriggerAfter =
    "after:absolute after:bottom-[0px] after:left-0 after:right-0 after:h-0.5 after:bg-accent after:opacity-0 after:content-[''] data-[state=active]:after:opacity-100";

  return (
    <TabsPrimitive.Trigger
      data-slot="tabs-trigger"
      data-test="tabs-trigger"
      className={c(
        tabTriggerBase,
        tabTriggerColors,
        tabTriggerAfter,
        className
      )}
      {...props}
    />
  );
}

function TabsTriggerLink({
  className = '',
  url,
  children,
}: TabsTriggerLinkProps) {
  const tabTriggerBase =
    'relative inline-flex -mb-px px-2 py-3 text-[16px] font-normal leading-[24px] tracking-tighter';
  const tabTriggerColors =
    'text-content-muted dark:data-[state=active]:text-content';
  const tabTriggerAfter =
    "after:absolute after:bottom-[0px] after:left-0 after:right-0 after:h-0.5 after:bg-accent after:opacity-0 after:content-[''] data-[state=active]:after:opacity-100";

  return (
    <a
      href={url}
      className={c(
        tabTriggerBase,
        tabTriggerColors,
        tabTriggerAfter,
        className
      )}
    >
      {children}
    </a>
  );
}

function TabsContent({
  className = '',
  ...props
}: React.ComponentProps<typeof TabsPrimitive.Content>) {
  return (
    <TabsPrimitive.Content
      data-slot="tabs-content"
      data-test="tabs-content"
      className={c(
        'w-full pt-8 text-left data-[state=inactive]:hidden',
        className
      )}
      {...props}
    />
  );
}
export { TabsContent, TabsList, TabsRoot, TabsTrigger, TabsTriggerLink };
